import AppendicesOptions from './AppendicesOptions';
import BudgetRisksOptions from './BudgetRisksOptions';
import BudgetSummaryOptions from './BudgetSummaryOptions';
import CashflowOptions from './CashflowOptions';
import ContractsOptions from './ContractsOptions';
import DashboardOptions from './DashboardOptions';
import DecisionsOptions from './DecisionsOptions';
import IssuesOptions from './IssuesOptions';
import PlansOptions from './PlansOptions';
import ProcurementOptions from './ProcurementOptions';
import RiskManagementOptions from './RiskManagementOptions';
import WorkforceOptions from './WorkforceOptions';

/**
 * The options panel of each section that has options of its own, by section
 * key. Each receives the section's options with its defaults filled in. A
 * panel flagged `showWhenDisabled` also renders while its section is off,
 * and receives `enabled`.
 */
const SECTION_OPTIONS = {
    dashboard: DashboardOptions,
    budget_summary: BudgetSummaryOptions,
    cashflow: CashflowOptions,
    workforce: WorkforceOptions,
    procurement: ProcurementOptions,
    contracts: ContractsOptions,
    budget_risks: BudgetRisksOptions,
    risk_management: RiskManagementOptions,
    issues: IssuesOptions,
    decisions: DecisionsOptions,
    plans: PlansOptions,
    appendices: AppendicesOptions,
};

export default SECTION_OPTIONS;
